var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[(_vm.formattedTime)?_c('p',{staticClass:"count-down__text",class:[{ 'm-white': _vm.isWhite }]},[_vm._v(" Time to complete booking: "+_vm._s(_vm.formattedTime)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }